<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-arrow-up-thin</v-icon>
            Enviar Ata {{ content.id }}
          </div>
        </v-toolbar>
        <div class="container dialog pa-2">
          <v-form ref="form" v-if="visible">
            <v-col cols="12">
              <div class="alert-message d-flex align-center mt-4">
                  <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                  <span>Atenção!<br />
                    Faça o upload de pelo menos um arquivo nos formatos .pdf, .png ou .jpeg, com tamanho máximo de 5MB.
                  </span>
              </div>
            </v-col>
            <v-row class="text-center mb-5">
              <v-col cols="6">
                <p>Ata de Formação</p>
                <v-btn
                  color="primary"
                  class="text-none"
                  rounded
                  depressed
                  @click="$refs.uploader.click()"
                >
                  <div>
                    <v-icon center> mdi-cloud-upload </v-icon>
                  </div>
                </v-btn>
                <input
                  ref="uploader"
                  class="d-none"
                  type="file"
                  accept=".jpeg, .jpg, .png, .pdf"
                  @click="$refs.uploader.value = null"
                  @change="adicionarArquivo"
                />
              </v-col>
              <v-col cols="6">
                <p>Baixar Modelo</p>
                <v-btn color="primary" @click="baixarModelo()" rounded
                  ><v-icon> mdi-cloud-download </v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-col cols="12">
              <label>Quantidade de Participantes Presentes:</label>
              <v-text-field
                outlined
                dense
                type="number"
                v-model="content.quantidadeDeParticipantes"
                :rules="[
                  $required,
                  (v) => $minValue(v, 1),
                  (v) => $maxValue(v, 1000),
                ]"
              ></v-text-field>
            </v-col>
          </v-form>
          <v-data-table
            class="mt-5"
            :headers="headers"
            :items="content.anexos"
            :items-per-page="10"
            :footer-props="$footerProps"
          >
            <template v-slot:[`item.nome`]="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:[`item.tipo`]="{ item }">
              .{{ getFileType(item.name) }}
            </template>
            <template v-slot:[`item.tamanho`]="{ item }">
              {{ getFileSize(item.size) }}
            </template>
            <template v-slot:[`item.acoes`]="{ item }">
              <sigfoco-tooltip
                small
                text="Realizar Download"
                icon="mdi-arrow-down"
                @click="baixarArquivo(item)"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                small
                text="Deletar Arquivo"
                icon="mdi-trash-can-outline"
                @click="removerArquivo(item)"
              ></sigfoco-tooltip>
            </template>
          </v-data-table>
        </div>
        <sigfoco-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          actionText="Salvar"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>
  
<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Ata } from "~/commons/classes/ata";
import AtaService from "~/services/manter-ata.service";

export default {
  props: new DialogProps(Ata),
  mixins: [AtaService],
  data: () => ({
    headers: [
      { text: "Nome do Arquivo", align: "center", value: "nome" },
      { text: "Tipo", align: "center", value: "tipo" },
      { text: "Tamanho", align: "center", value: "tamanho" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ],
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar a operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const formData = new FormData();
          formData.append(`ComandoCriarAta`, JSON.stringify(this.content));
          this.content.anexos.forEach((a) => formData.append(`Arquivos`, a));
          return this.$enviarAta(this.content.id, formData);
        });
      };
      if (this.$validarFormulario() && this.validarExisteAoMenosUmArquivo()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },

    async baixarModelo() {
      const url = "/docs/modelo-de-ata.docx";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "modelo-de-ata.docx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.$notifySuccess("Operação realizada com sucesso.");
    },
    adicionarArquivo(e) {
      const file = e.target.files[0];
      if (!file) return;

      if (!this.validarArquivoType(file)) {
        this.$notifyError("Formato de arquivo inválido. Aceito apenas .pdf, .png ou .jpeg.");
        return;
      }
      if(this.validarArquivoDuplicado(file)) {
        this.$notifyError("Já existe um documento com esse nome. Insira um outro arquivo.");
        return;
      }
      this.content.anexos.push(file);
    },
    validarArquivoType(file) {
      const validTypes = ["application/pdf", "image/png", "image/jpeg"];
      return validTypes.includes(file.type);
    },
    validarArquivoDuplicado(file) {
      return this.content.anexos.some((anexo) => anexo.name === file.name);
    },
    validarExisteAoMenosUmArquivo() {
      if (this.content.anexos.length === 0) {
        this.$notifyError("É necessário enviar no mínimo um arquivo de Ata de formação.");
        return false;
      }
      return true;
    },
    baixarArquivo(item) {
      const url = URL.createObjectURL(item);
      const a = document.createElement("a");
      a.href = url;
      a.download = item.name || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    removerArquivo(item) {
      this.content.anexos = this.content.anexos.filter(
        (anexo) => anexo !== item
      );
    },
    getFileType(fileName) {
      return fileName.split(".").pop().toLowerCase();
    },
    getFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + " MB";
      } else {
        return (bytes / 1024).toFixed(2) + " KB";
      }
    },
  },
};
</script>
<style scoped>
.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
</style>